import { createAction } from '@reduxjs/toolkit';

export const PARK_CALL_ACTION_TYPE = 'saga/parkCall';
export const parkCallAction = createAction(PARK_CALL_ACTION_TYPE);
